{
  "sdk-download-android": "下载安卓版",
  "sdk-connect": "关联",
  "sdk-download-ios": "下载iOS版",
  "sdk-install": "安装",
  "sdk-modal-instruct-1": "1.打开币安App",
  "sdk-modal-instruct-2": "2.点击主屏幕的{{icon}}",
  "sdk-modal-title": "关联币安",
  "sdk-no-app": "尚未安装币安App？"
}